import { mainSiteConfig } from "@/config/main";

const GetCurrentAppConfig = () => {
  return mainSiteConfig.tenants[process.env.NEXT_PUBLIC_APP_ID];
};

export default GetCurrentAppConfig;
